import { useState } from "react";
import { btnCancel, btnOne, inputStyleTwo, label, subTitle, title } from "../utils/style";


function CertificationRequestForm({ setShowModal, submitHandler, image, courseTitle }) {

    return(
        <div className="flex justify-center items-center bg-black bg-opacity-50  p-4 fixed top-0 left-0 h-screen w-screen z-50">
            <div className="px-4 py-8 bg-white w-full rounded-lg shadow-xl">
                <div className="text-center"><span className={title}>Request Certification</span></div>
                <div className="py-2">
                    <div className="flex justify-center">
                        <img src={image} />
                    </div>
                    <div className={subTitle}>{courseTitle}</div>
                </div>
                <div className="flex justify-between items-center gap-4 py-4">
                    <button className={btnCancel} onClick={() => setShowModal(false)}>Cancel</button>
                    <button onClick={() => submitHandler()} className={btnOne}>Submit</button>
                </div>
            </div>
        </div>
    )
}

export default CertificationRequestForm;